export const Colors = {
    GREEN: '#37b37a',
    ORANGE: '#fcab01',
    RED: '#ff563e',
    WHITE: '#fff',
    DARK: '#00384c'
};
